/* BLOOM'S HEAVEN — reliable sticky custom navbar.
   The announcement bar remains in normal flow; only the custom navbar pins to viewport top. */
(function () {
  'use strict';
  var SELECTOR = 'header[class*="ai-header-"]';
  var nav = null, spacer = null, originalStyles = {}, pinStartY = 0, pinned = false, originalParent = null;
  var observer = null, resizeObserver = null, retryTimer = null;
  var STYLE_PROPS = ['position','top','right','bottom','left','width','max-width','margin','z-index','transform','transition'];

  function rememberStyles(el) {
    var saved = {};
    STYLE_PROPS.forEach(function (prop) {
      saved[prop] = { value: el.style.getPropertyValue(prop), priority: el.style.getPropertyPriority(prop) };
    });
    return saved;
  }
  function restoreStyles(el) {
    STYLE_PROPS.forEach(function (prop) {
      var item = originalStyles[prop];
      if (item && item.value) el.style.setProperty(prop, item.value, item.priority);
      else el.style.removeProperty(prop);
    });
  }
  function measureStart() {
    if (nav && !pinned && nav.isConnected) pinStartY = nav.getBoundingClientRect().top + window.scrollY;
  }
  function sizeSpacer() {
    if (!nav || !spacer) return;
    spacer.style.height = Math.ceil(nav.getBoundingClientRect().height) + 'px';
    spacer.style.width = '100%';
  }
  function pin() {
    if (pinned || !nav || !spacer) return;
    sizeSpacer();
    spacer.style.display = 'block';
    originalParent = spacer.parentNode;
    document.body.appendChild(nav);
    nav.style.setProperty('position', 'fixed', 'important');
    nav.style.setProperty('top', '0px', 'important');
    nav.style.setProperty('right', '0px', 'important');
    nav.style.setProperty('bottom', 'auto', 'important');
    nav.style.setProperty('left', '0px', 'important');
    nav.style.setProperty('width', '100%', 'important');
    nav.style.setProperty('max-width', 'none', 'important');
    nav.style.setProperty('margin', '0', 'important');
    nav.style.setProperty('transform', 'none', 'important');
    nav.style.setProperty('transition', 'none', 'important');
    nav.style.setProperty('z-index', '2147483647', 'important');
    nav.classList.add('bh-navbar-pinned');
    pinned = true;
  }
  function unpin() {
    if (!pinned || !nav || !spacer) return;
    nav.classList.remove('bh-navbar-pinned');
    if (spacer.parentNode) spacer.parentNode.insertBefore(nav, spacer.nextSibling);
    restoreStyles(nav);
    spacer.style.display = 'none';
    pinned = false;
  }
  function onScroll() {
    if (!nav || !nav.isConnected) return;
    if (window.scrollY >= Math.max(0, pinStartY - 1)) pin();
    else unpin();
  }
  function init() {
    var found = document.querySelector(SELECTOR);
    if (!found || !found.parentNode) return false;
    if (nav === found && spacer && spacer.isConnected) return true;
    if (nav && nav.isConnected && nav !== found) {
      unpin();
      if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
    }
    nav = found;
    originalStyles = rememberStyles(nav);
    spacer = document.createElement('div');
    spacer.className = 'bh-navbar-sticky-spacer';
    spacer.style.cssText = 'display:none;height:0;width:100%;flex:0 0 auto;visibility:hidden;pointer-events:none;';
    nav.parentNode.insertBefore(spacer, nav);
    measureStart();
    if (resizeObserver) resizeObserver.disconnect();
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(function () {
        if (pinned) sizeSpacer();
        else measureStart();
      });
      resizeObserver.observe(nav);
    }
    onScroll();
    return true;
  }
  function start() {
    if (init()) {
      if (observer) observer.disconnect();
      if (retryTimer) window.clearInterval(retryTimer);
      retryTimer = null;
      return;
    }
    if (!observer && window.MutationObserver) {
      observer = new MutationObserver(function () {
        if (init()) {
          observer.disconnect();
          observer = null;
          if (retryTimer) window.clearInterval(retryTimer);
          retryTimer = null;
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
    if (!retryTimer) {
      var attempts = 0;
      retryTimer = window.setInterval(function () {
        attempts++;
        if (init() || attempts >= 80) {
          window.clearInterval(retryTimer);
          retryTimer = null;
        }
      }, 250);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (pinned) sizeSpacer();
    else measureStart();
    onScroll();
  }, { passive: true });
  window.addEventListener('pageshow', function () { start(); onScroll(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();